import Link from "next/link";
import classNames from "classnames";
import PropTypes from "prop-types";

import { Section, Grid, Flow } from "components/Layout";
import Button from "/components/Button";
import Block from "/components/Layout/Block";

import styles from "./Footer.module.scss";

const Footer = ({ frontpage = false, slug = "" }) => {
  const footerClass = classNames({
    [styles.footer]: true,
    [styles[`footer-frontpage`]]: frontpage
  });

  const isHiddenImage = slug === "bestilt";

  return (
    <>
      {/* Footer image for frontpage */}
      {frontpage && (
        <img src="/images/footer-tall.png" alt="" className={styles.footerImageFrontpage} />
      )}
      <footer className={footerClass}>
        {/* Footer image for other pages */}
        {!frontpage && !isHiddenImage && (
          <img src="/images/footer-slim.png" alt="" className={styles.footerImage} />
        )}

        <Section outer="none" inner="footer" color="red-40">
          <Grid horizontalCenter>
            <nav>
              <Flow>
                <p>
                  <Link className="link-underline" href="/whee-sykkel-abonnement">
                    Whee!-sykkel abonnement
                  </Link>
                </p>

                <p>
                  <Link className="link-underline" href="/sykler">
                    Våre sykler
                  </Link>
                </p>

                <p>
                  <Link className="link-underline" href="/service">
                    Service
                  </Link>
                </p>

                <p>
                  <Link className="link-underline" href="/whee-for-bedrifter">
                    Whee! til bedrift
                  </Link>
                </p>

                <div>
                  <Button color="red" link="/sykler" menu>
                    Bestill Whee!-sykkel
                  </Button>
                </div>
              </Flow>
            </nav>

            <nav>
              <Flow>
                <p>
                  <Link className="link-underline boxLeft" href="/hvem-er-whee">
                    Om Whee!
                  </Link>
                </p>

                <p>
                  <Link className="link-underline boxLeft" href="/team">
                    Whee! team
                  </Link>
                </p>

                <p>
                  <Link className="link-underline" href="/artikler">
                    Artikler
                  </Link>
                </p>
                <p>
                  <Link className="link-underline" href="/personvern-og-cookies">
                    Personvern & cookies
                  </Link>
                </p>
                <p>
                  <Link className="link-underline" href="/kundeavtale-sykkelabonnement">
                    Leieavtale Whee! Bike
                  </Link>
                </p>
              </Flow>
            </nav>

            <Flow>
              <Block bottom={4}>
                <Link className="link-underline" href="/min-side?referer=min-side">
                  Min side
                </Link>
              </Block>
              <Block bottom={4}>
                <Link className="link-underline" href="/min-bedrift?referer=min-bedrift">
                  Min bedrift
                </Link>
              </Block>

              <Block bottom={4}>
                <Link className="link-underline" href="https://www.wheestore.no/">
                  Nettbutikk
                </Link>
              </Block>

              <Block bottom={4}>
                <div className={styles.some}>
                  <a
                    href="https://www.instagram.com/wheebikeoslo/"
                    title="Whee! på Instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src="/images/instagram.svg" alt="Instagram ikon" />
                  </a>
                  <a
                    href="https://www.facebook.com/wheebike/"
                    title="Whee! på Facebook"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src="/images/facebook.svg" alt="Facebook ikon" />
                  </a>
                </div>
              </Block>

              <a href="mailto:hei@whee.no" className="link-underline">
                hei@whee.no
              </a>

              <Block bottom={6}>
                <p>Nordlandsgata 5, 0483 Oslo</p>
              </Block>
            </Flow>
          </Grid>
        </Section>
      </footer>
    </>
  );
};

Footer.propTypes = {
  frontpage: PropTypes.bool,
  slug: PropTypes.string
};

export default Footer;
